<template>
	<div class="post-card">
		<form>
			<div class="post-card-header">
				<div>{{ userName }}</div>
				<div>{{ postCreateTime }}</div>
			</div>
			<div class="post-card-body">
				<div class="post-card-body-content">
					<p>{{ post.post_message }}</p>
				</div>
				<div
					v-if="
						post.post_attachments &&
							post.post_attachments.length > 0
					"
					class="post-card-body-attachments"
				>
					<BaseAttachment
						:isCreate="false"
						:attachments="post.post_attachments"
					/>
				</div>
			</div>
			<div class="post-card-footer">
				<div
					class="post-card-footer-button"
					v-if="
						post.post_attachments &&
							post.post_attachments.length > 0
					"
					@click.prevent="clickDownloadAll"
				>
					Download All Files
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import moment from 'moment'
import { attachmentOriginalName, fetchFile } from '@/utils/Help.js'
import NProgress from 'nprogress'
import { getDownloadSignedUrl } from '@/services/S3Service.js'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export default {
	name: 'PostCard',
	computed: {
		userName() {
			const userName = this.post.user_name
			return userName
		},
		postCreateTime() {
			return moment(this.post.create_time_stamp).format(
				'D MMM YY, h:mm:ss a'
			)
		}
	},
	props: {
		post: {
			type: Object,
			require: true
		}
	},
	methods: {
		async clickDownloadAll() {
			NProgress.start()
			let zip = new JSZip()
			const token = sessionStorage.getItem('token')
			const attachments = this.post.post_attachments
			for (let i = 0; i < attachments.length; i++) {
				const folder = attachments[i].folder
				const name = attachments[i].name
				const fileName = attachmentOriginalName(name)

				try {
					const response = await getDownloadSignedUrl(
						folder,
						name,
						token
					)
					const URL = response.data.url

					const blob = await fetchFile(URL)
					zip.file(fileName, blob)
				} catch (e) {
					NProgress.done()
					console.log(e)
					const notification = {
						type: 'error',
						message: `Oops! Something went wrong.`
					}

					this.$store.dispatch('notification/add', notification, {
						root: true
					})
				}
			}
			zip.generateAsync({ type: 'blob' }).then(function(content) {
				saveAs(content, 'Attachments.zip')
			})
			NProgress.done()
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/postCard.scss';
</style>
